import React from 'react';
import useTheme from '../hooks/useTheme';

interface StatusPillProps {
  status: 'LIVE' | 'COMING SOON' | 'PREVIEW' | 'PARTLY LIVE';
  size?: 'small' | 'medium';
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, size = 'medium' }) => {
  const { theme } = useTheme();

  const isLive = status === 'LIVE';
  const isPartlyLive = status === 'PARTLY LIVE';

  const sizeStyles = {
    small: {
      padding: '3px 8px',
      fontSize: '10px',
    },
    medium: {
      padding: '4px 12px',
      fontSize: '12px',
    },
  };

  const getBackgroundColor = () => {
    if (isLive) return theme.colors.green.g1;
    if (isPartlyLive) return theme.colors.accent.korea;
    return theme.text.muted;
  };

  const getTextColor = () => {
    if (isLive || isPartlyLive) return theme.text.primary;
    return theme.background.default;
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        ...sizeStyles[size],
        borderRadius: '12px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        backgroundColor: getBackgroundColor(),
        color: getTextColor(),
      }}
    >
      {status}
    </span>
  );
};

